// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1nPdY","header":"PatientBlock_header__5Qf1T","label":"PatientBlock_label__2Bi25","option":"PatientBlock_option__1wtAS"};